import { __decorate, __extends, __metadata } from 'tslib';
import { Injectable, Component, ViewEncapsulation, ChangeDetectorRef, Input, ChangeDetectionStrategy, forwardRef, ViewChild, ViewContainerRef, Directive, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIKitIconsModule } from '@uikit/components/uk-icons';
import { UkGroupComponent, UkChildItemComponent, UIKitCommonModule } from '@uikit/components/common';
import { Subject } from 'rxjs';

var UkStepperService = /** @class */ (function () {
    function UkStepperService() {
        this.moveTrigger = new Subject();
    }
    Object.defineProperty(UkStepperService.prototype, "trigger", {
        get: function () { return this.moveTrigger.asObservable(); },
        enumerable: true,
        configurable: true
    });
    /**
     * Move step
     * @param position position
     */
    UkStepperService.prototype.moveStep = function (position) { this.moveTrigger.next(position); };
    UkStepperService = __decorate([
        Injectable()
    ], UkStepperService);
    return UkStepperService;
}());

var UkStepperComponent = /** @class */ (function (_super) {
    __extends(UkStepperComponent, _super);
    function UkStepperComponent(_ts, cdr) {
        var _this = _super.call(this, 'stepper', cdr) || this;
        _ts.trigger.subscribe(function (p) {
            _this.move(p);
            cdr.detectChanges();
        });
        return _this;
    }
    Object.defineProperty(UkStepperComponent.prototype, "activeStep", {
        get: function () { return this._items.find(function (item) { return item.active; }); },
        enumerable: true,
        configurable: true
    });
    UkStepperComponent.prototype.selectCorrect = function () {
        var _this = this;
        var prevItem = this._items.find(function (it) { return it.index === (_this.selectedIndex - 1); });
        var valid = true;
        if (prevItem) {
            valid = prevItem.completed;
        }
        if (valid) {
            this.selectIndex(this.selectedIndex, true);
        }
    };
    UkStepperComponent.prototype.ngAfterContentInit = function () {
        _super.prototype.proccessItems.call(this, this._items);
        this.selectIndex(this.selectedIndex, false);
    };
    UkStepperComponent = __decorate([
        Component({
            selector: 'uk-stepper',
            template: "<ol class=\"uk-progress-track\" role=\"tablist\">\r\n  <li class=\"uk-progress-step\"\r\n    role=\"tab\" tabindex=\"0\"\r\n    *ngFor=\"let step of _items; let i = index\"\r\n    [attr.id]=\"step.id + '-label'\"\r\n    [attr.aria-selected]=\"step.active\"\r\n    [attr.aria-controls]=\"step.id\"\r\n    [attr.tabindex]=\"step.active ? 0 : -1\"\r\n    [ukAutofocus]=\"selectedIndex === step.index\"\r\n    [ngClass]=\"{'active': step.active, 'done': step.completed, 'wip': step.inProgress }\">\r\n    <div class=\"uk-progress-line\"></div>\r\n    <div class=\"uk-step-icon-wrap\" ukIcon=\"check-mark\"></div>\r\n    <span class=\"uk-progress-text\" [ngClass]=\"{'hide-sm hide-xs show-md': _items.length > 3}\">\r\n      {{step.textLabel}}\r\n    </span>\r\n  </li>\r\n</ol>\r\n\r\n<div aria-hidden=\"true\" class=\"uk-progress-title text-center hide-sm hide-md hide-lg\" *ngIf=\"_items.length > 3\">\r\n  {{activeStep.textLabel}}\r\n</div>\r\n\r\n<div class=\"uk-progress-step-body\">\r\n  <uk-step-body \r\n    *ngFor=\"let step of _items; let i = index\"\r\n    [attr.id]=\"step.id\"\r\n    [attr.aria-labelledby]=\"step.id + '-label'\"\r\n    [attr.aria-hidden]=\"!step.active\"\r\n    [attr.aria-expanded]=\"step.active\"\r\n    [step]=\"step\">\r\n    <ng-container [ngTemplateOutlet]=\"step._content\"></ng-container>\r\n  </uk-step-body>\r\n</div>",
            encapsulation: ViewEncapsulation.None,
            providers: [UkStepperService],
            host: { 'class': 'uk-stepper' }
        }),
        __metadata("design:paramtypes", [UkStepperService, ChangeDetectorRef])
    ], UkStepperComponent);
    return UkStepperComponent;
}(UkGroupComponent));

var UkStepComponent = /** @class */ (function (_super) {
    __extends(UkStepComponent, _super);
    function UkStepComponent() {
        var _this = _super.call(this, 'step') || this;
        _this.completed = false;
        _this.inProgress = false;
        return _this;
    }
    UkStepComponent_1 = UkStepComponent;
    var UkStepComponent_1;
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UkStepComponent.prototype, "completed", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UkStepComponent.prototype, "inProgress", void 0);
    UkStepComponent = UkStepComponent_1 = __decorate([
        Component({
            selector: 'uk-step',
            template: "<ng-template><ng-content></ng-content></ng-template>",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush,
            providers: [{
                    provide: UkChildItemComponent,
                    useExisting: forwardRef(function () { return UkStepComponent_1; })
                }]
        }),
        __metadata("design:paramtypes", [])
    ], UkStepComponent);
    return UkStepComponent;
}(UkChildItemComponent));

var UkStepBodyComponent = /** @class */ (function () {
    function UkStepBodyComponent(cdr) {
        this.cdr = cdr;
    }
    UkStepBodyComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.step.active) {
            this.templateContent.createEmbeddedView(this.step.content);
        }
        this.suscription = this.step.activeChange.subscribe(function (active) {
            if (active) {
                _this.templateContent.createEmbeddedView(_this.step.content);
            }
            else {
                _this.templateContent.clear();
            }
            _this.cdr.detectChanges();
        });
    };
    UkStepBodyComponent.prototype.ngOnDestroy = function () { this.suscription.unsubscribe(); };
    __decorate([
        Input(),
        __metadata("design:type", UkStepComponent)
    ], UkStepBodyComponent.prototype, "step", void 0);
    __decorate([
        ViewChild('templateContent', { read: ViewContainerRef, static: true }),
        __metadata("design:type", ViewContainerRef)
    ], UkStepBodyComponent.prototype, "templateContent", void 0);
    UkStepBodyComponent = __decorate([
        Component({
            selector: 'uk-step-body',
            template: "<ng-template #templateContent></ng-template>",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush,
            host: {
                'role': 'tabpanel',
                'class': 'uk-step-body',
            }
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef])
    ], UkStepBodyComponent);
    return UkStepBodyComponent;
}());

var UkStepperNextDirective = /** @class */ (function () {
    function UkStepperNextDirective(_ts) {
        this._ts = _ts;
    }
    UkStepperNextDirective.prototype.clickFired = function () { this._ts.moveStep(1); };
    UkStepperNextDirective = __decorate([
        Directive({
            selector: 'button[ukStepperNext]',
            host: { '(click)': 'clickFired()' }
        }),
        __metadata("design:paramtypes", [UkStepperService])
    ], UkStepperNextDirective);
    return UkStepperNextDirective;
}());
var UkStepperPreviousDirective = /** @class */ (function () {
    function UkStepperPreviousDirective(_ts) {
        this._ts = _ts;
    }
    UkStepperPreviousDirective.prototype.clickFired = function () { this._ts.moveStep(-1); };
    UkStepperPreviousDirective = __decorate([
        Directive({
            selector: 'button[ukStepperPrevious]',
            host: { '(click)': 'clickFired()' }
        }),
        __metadata("design:paramtypes", [UkStepperService])
    ], UkStepperPreviousDirective);
    return UkStepperPreviousDirective;
}());

var UIKitStepperModule = /** @class */ (function () {
    function UIKitStepperModule() {
    }
    UIKitStepperModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                UIKitIconsModule,
                UIKitCommonModule
            ],
            declarations: [
                UkStepperComponent,
                UkStepBodyComponent,
                UkStepComponent,
                UkStepperNextDirective,
                UkStepperPreviousDirective
            ],
            exports: [
                UkStepperComponent,
                UkStepComponent,
                UkStepperNextDirective,
                UkStepperPreviousDirective
            ]
        })
    ], UIKitStepperModule);
    return UIKitStepperModule;
}());

export { UIKitStepperModule, UkStepperComponent as ɵa, UkStepperService as ɵb, UkStepBodyComponent as ɵc, UkStepComponent as ɵd, UkStepperNextDirective as ɵe, UkStepperPreviousDirective as ɵf };
//# sourceMappingURL=uikit-components-uk-stepper.js.map
